import { ArrowUpRight, Lock } from "lucide-react";

const TONES = ["bg-lime/60", "bg-sand", "bg-[#DCE5D7]", "bg-[#F4E3DD]"];
const initials = (name) => name.replace(/[^A-Za-z0-9 ]/g, "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const PortfolioCard = ({ p }) => {
  const body = (
    <>
      <div className={`grid h-28 place-items-center overflow-hidden rounded-lg ${p.logo ? "border border-ink/10 bg-white" : TONES[p.id % TONES.length]}`}>
        {p.logo ? (
          <img src={p.logo} alt={`${p.name} logo`} width="256" height="256" loading="lazy" decoding="async" className="h-24 w-24 object-contain" />
        ) : (
          <span className="font-display text-3xl font-extrabold tracking-tight text-ink/80" aria-hidden>{initials(p.name)}</span>
        )}
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <h3 className="font-display text-lg font-semibold leading-snug text-ink">{p.name}</h3>
        {p.url ? <ArrowUpRight className="mt-1 h-4 w-4 shrink-0 text-ink/50 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" aria-hidden /> : <Lock className="mt-1 h-4 w-4 shrink-0 text-ink/40" aria-hidden />}
      </div>
      <p className="mt-1 text-sm text-ink/65">{[p.note, p.country].filter(Boolean).join(" · ") || p.category}</p>
      <p className="mt-3 truncate text-xs font-semibold text-sageDeep">{p.host || "Private system"}</p>
    </>
  );
  const cls = "group block h-full rounded-xl border border-ink/10 bg-white p-4 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:border-ink hover:shadow-[0_20px_40px_-28px_rgba(36,37,34,0.5)]";
  return p.url ? (
    <a href={p.url} target="_blank" rel="noopener noreferrer" className={cls} aria-label={`${p.name} (opens in a new tab)`} data-testid="portfolio-card">{body}</a>
  ) : (
    <div className={`${cls} hover:translate-y-0`} data-testid="portfolio-card">{body}</div>
  );
};
